import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Context } from "../../../../../../store/store";
import { StoreContextType } from "@/store/types";
import { Button } from "../../../components";
import { PersonalityMatrix } from "../../../components/personality-matrix";
import { useUrlState } from "../../../hooks";
import { useReflectionPersonalSummaryData } from "../../../../FuturebilityCockpit/hooks/useReflectionPersonalSummaryData";
import { END_SUB_URL } from "../../../../constants";
import { useTranslatedPersonalityRoles } from "./useTranslatedPersonalityRoles";
import { PersonalityRole } from "../../../../../../types/domain-types";

import "./styles.scss";

export function ReflectionPersonalSummary() {
  const { t } = useTranslation();
  const [{ publicTest }] = useContext<StoreContextType>(Context as any);
  const { sessionId, navigateToParticipationPage } = useUrlState();
  const summaryData = useReflectionPersonalSummaryData({
    entries: publicTest.entries,
    sessionId,
  });
  const translatedKeys = useTranslatedPersonalityRoles();

  function handleNextClick() {
    navigateToParticipationPage({ subPage: END_SUB_URL });
  }

  return (
    <div className="tg_reflection-personal-summary">
      <div className="tg_reflection-report">
        <div className="tg_column">
          <PersonalityMatrix
            activeGridIndex={summaryData.activeQuadrantIndex}
            gridLabels={[
              translatedKeys[PersonalityRole.Mediator].name,
              translatedKeys[PersonalityRole.Advisor].name,
              translatedKeys[PersonalityRole.Innovator].name,
              translatedKeys[PersonalityRole.Controller].name,
              translatedKeys[PersonalityRole.Director].name,
              translatedKeys[PersonalityRole.Motivator].name,
              translatedKeys[PersonalityRole.Brakeman].name,
              translatedKeys[PersonalityRole.Critic].name,
              translatedKeys[PersonalityRole.Driver].name,
            ]}
            mainLabels={{
              left: t("frontend.test.reflectionResults.community", "Community"),
              right: t("frontend.test.reflectionResults.success", "Success"),
              top: t(
                "frontend.test.reflectionResults.opportunities",
                "Opportunities"
              ),
              bottom: t("frontend.test.reflectionResults.security", "Security"),
            }}
            points={summaryData.points}
          />
          <div className="role-wrapper">
            <div className="title">
              {t("frontend.test.reflectionResults.role", "Role")}:
            </div>
            <div className="personality-role">
              {translatedKeys[summaryData.personalityRole].name}
            </div>
          </div>
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: translatedKeys[summaryData.personalityRole].description,
            }}
          ></div>
        </div>
      </div>
      <div className="footer">
        <div className="tg_column">
          <Button next className="button" onClick={handleNextClick}>
            {t("frontend.test.analyticsResults.next", "Next")}
          </Button>
        </div>
      </div>
    </div>
  );
}
